import { createContext } from 'react';
import { IAgrConfiguration } from '../models/ConfigurationModel';

const AgrConfigurationContext = createContext<IAgrConfiguration | undefined>(undefined);

export const AgrConfigurationProvider = AgrConfigurationContext.Provider;

export default AgrConfigurationContext;
